
import Vue from 'vue'
import { TIME_UNITS } from '@/constants/business'

const errCallback = (time, timeInterval, drift) => {
  if (['development', 'customTest'].includes(Vue.getEnvironmentName())) {
    // eslint-disable-next-line no-console
    console.log(`${time.format('YYYY-MM-DDTHH:mm:ss.SSS')} Отклонение таймера. Установленный интервал: ${timeInterval}. Реальный интервал: ${drift}`)
  }
}

const AccurateTimeInterval = function (intervalUnit = TIME_UNITS.MILLISECONDS, errorCallback = errCallback) {
  // startTime - серверное время
  this.startInterval = (timeInterval, repeatCallback) => {
    // сохраняем для дальнейшего использования длину интервала и колбэк для повторения
    this.timeInterval = timeInterval
    this.repeatCallback = repeatCallback
    // текущее локальное время
    const localNow = Vue.prototype.$moment()
    // ожидаемое время выполнения колбэка
    this.expected = localNow.add(this.timeInterval, intervalUnit)
    // устанавливаем таймер для запуска колбэка с пересчетом интервала перезапуска
    this.timeout = setTimeout(this.invokeWithFixedInterval, this.timeInterval)
    this.id = this.timeout

    // if (['development', 'customTest'].includes(Vue.getEnvironmentName())) {
    //   // eslint-disable-next-line no-console
    //   console.log(`Timer started id=${this.id} expected=${this.expected.format('HH:mm:ss.SSS')}`)
    // }
  }

  this.stop = () => {
    if (this.timeout) {
      clearTimeout(this.timeout)
      // if (['development', 'customTest'].includes(Vue.getEnvironmentName())) {
      //   // eslint-disable-next-line no-console
      //   console.log(`Timer stop id=${this.id}`)
      // }
    }
  }

  this.invokeWithFixedInterval = () => {
    // текущее локальное время
    const localNow = Vue.prototype.$moment()
    // a.diff(b, 'years');       // 1
    // a.diff(b, 'years', true); // 1.75
    // вычисляем разницу м/у ожидаемым и реальным временем вызова
    const drift = localNow.diff(this.expected, intervalUnit, true)

    if (drift > this.timeInterval) {
      if (errorCallback) {
        errorCallback(localNow, this.timeInterval, drift)
      }
    }

    let fixedInterval = this.timeInterval - drift
    let stepMilliseconds = this.timeInterval

    if (fixedInterval < 0) {
      fixedInterval = 0
      stepMilliseconds = drift
    }

    this.expected = this.expected.add(stepMilliseconds, intervalUnit)

    // if (['development', 'customTest'].includes(Vue.getEnvironmentName())) {
    //   // eslint-disable-next-line no-console
    //   console.log(`id=${this.id} fixedInterval=${fixedInterval} stepMilliseconds=${stepMilliseconds} expected=${this.expected.format('HH:mm:ss.SSS')}`)
    // }

    try {
      // вызов переданного при инициализации класса колбэка
      this.repeatCallback(stepMilliseconds)
    } catch { }

    // устанавливаем таймер для запуска текущего метода с новым интервалом
    this.timeout = setTimeout(this.invokeWithFixedInterval, fixedInterval)
  }
}

export default AccurateTimeInterval
